import React, { Children } from 'react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Chrome Couture',
  description: 'Our signature liquid metal finishes. From subtle silver tips to full-coverage mirror glaze, meticulously applied for flawless reflection.',
  price: 'From $85'
}, {
  title: 'Glass Skin Manicure',
  description: 'A luxury hand treatment focusing on ultra-hydration and cuticle perfection, finishing with a high-gloss, sheer jelly tint.',
  price: 'From $65'
}, {
  title: 'The Full Lab Experience',
  description: 'The ultimate pampering session. Includes extended massage, custom chrome art design, and a complimentary iridescent elixir.',
  price: 'From $150'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function ServicesSection() {
  return <section id="services" className="w-full py-24 px-6 md:px-12" data-id="element-127">
      <div className="max-w-7xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-129">
          <h2 className="font-syncopate font-bold text-4xl md:text-5xl text-black tracking-widest mb-4" data-id="element-130">
            OUR SERVICES
          </h2>
          <div className="h-px w-24 bg-black/20 mx-auto" data-id="element-131" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-132">
          {services.map((service, index) => <motion.div key={index} variants={cardVariants} whileHover={{
          y: -10,
          scale: 1.02
        }} className="glass-panel rounded-3xl p-8 flex flex-col h-full transition-all duration-300" data-id="element-133">
              <h3 className="font-syncopate font-bold text-xl mb-4 text-black tracking-wide" data-id="element-134">
                {service.title}
              </h3>
              <p className="text-black/70 font-light leading-relaxed mb-8 flex-grow" data-id="element-135">
                {service.description}
              </p>
              <div className="mt-auto pt-6 border-t border-black/10 flex justify-between items-center" data-id="element-136">
                <span className="font-medium text-black/90" data-id="element-137">
                  {service.price}
                </span>
                <button className="text-xs font-syncopate font-bold tracking-wider uppercase text-black hover:text-pink-500 transition-colors" data-id="element-138">
                  Book
                </button>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}